import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import AssTasksComp from './AssTasksComp'

function AssTasks() {
  return (
    <div>        
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <AdmissionTopNotice/>
              <AssTasksComp/>
                  
            </div>
        </div>  
    </div>
  )
}

export default AssTasks